
export default function About() {
  return (
    <div className="bg-gradient-to-b from-amber-50/50 to-white py-32 px-8 lg:px-16">
      <div className="max-w-4xl mx-auto text-center space-y-12">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-2 h-2 rounded-full bg-gray-400"></div>
          <span className="text-sm uppercase tracking-wider text-gray-500">About Us</span>
        </div>
        
        <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
          Expert Team Building Premium iOS Solutions
        </h2>
        
        <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
          FLAMA S.R.L. is dedicated to creating innovative mobile applications that prioritize user security and experience. Our team combines technical expertise with creative design to deliver products that stand out in the iOS ecosystem. We focus on developing solutions that not only meet but exceed user expectations in privacy, performance, and usability.
        </p>
      </div>
    </div>
  );
}
